module.exports = __webpack_public_path__ + "static/media/006_DetailView@2x.c83587d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/optus/006_DetailView@2x.png
// module id = 568
// module chunks = 0